// extracted by mini-css-extract-plugin
export default {"mCard":"Zz-z","image":"_z-z","imageNoBackground":"aA-z","imageHasCategory":"bA-z","fullWidth":"cA-z"};